import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import BrokerageLoginForm from 'Components/Banking/BrokerageLoginForm';
import BrokerageOrderForm from 'Components/Banking/BrokerageOrderForm';
import './Brokerage.css';

export default function BrokerageOrderTemplates(props) {

	const x = props.x;
	const wafId = props.id;
	const dialogFormId = "form-" + props.id;

	const [reloadKey, setReloadKey] = React.useState(0);
	const [placeTarget, setPlaceTarget] = React.useState(null);

	// Table.js ruft onAddColumn(key, value) je Zeile spaltenweise auf, ohne die
	// gesamte Zeile mitzugeben - siehe gleiches Muster in BankAccounts.js.
	let rowConnectionid = 0;
	let rowAccountlabel = '';
	let rowInstrumentid = '';
	let rowVenueid = '';
	let rowSide = 'BUY';
	let rowQuantity = '';
	let rowLimitprice = '';

	const formFields =
		<React.Fragment>
			<FormElement type="text" x={x} wafId={wafId} id="connectionid" mandatory={true} title="Verbindungs-ID (comdirect, siehe Banking → Konten)" fieldValue="" maxLength="10" />
			<FormElement type="text" x={x} wafId={wafId} id="label" mandatory={true} title="Bezeichnung" fieldValue="" maxLength="100" />
			<FormElement type="text" x={x} wafId={wafId} id="instrumentid" mandatory={true} title="Wertpapierkennung (ISIN/instrumentId)" fieldValue="" maxLength="50" />
			<FormElement type="text" x={x} wafId={wafId} id="venueid" mandatory={true} title="Handelsplatz (venueId)" fieldValue="" maxLength="50" />
			<FormElement type="text" x={x} wafId={wafId} id="side" mandatory={true} title="Seite (BUY oder SELL)" fieldValue="BUY" maxLength="4" />
			<FormElement type="text" x={x} wafId={wafId} id="quantity" mandatory={true} title="Stückzahl" fieldValue="" maxLength="14" />
			<FormElement type="text" x={x} wafId={wafId} id="limitprice" mandatory={true} title="Limit (EUR)" fieldValue="" maxLength="14" />
		</React.Fragment>

	return (
		<React.Fragment>
			<ModuleTable
				id={props.id}
				tableId="templateid"
				dialogFormId={dialogFormId}
				x={x}
				classes="module-brokerage-order-templates"
				tableClasses="brokerage-order-templates-table"
				title={props.title}
				addDeleteRow={true}
				addTitle="Neue Ordervorlage anlegen"
				formTitle="Ordervorlage"
				module="Banking"
				listTask="BrokerageTemplateList"
				deleteTask="BrokerageTemplateDelete"
				reloadKey={reloadKey}
				onAddHeader={(addHeader) => {
					addHeader('Bezeichnung');
					addHeader('Konto');
					addHeader('Seite');
					addHeader('Stückzahl');
					addHeader('Limit');
					addHeader('Platzieren');
				}}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'templateid':
							return false;
						case 'connectionid':
							rowConnectionid = value;
							return false;
						case 'accountlabel':
							rowAccountlabel = value;
							return value;
						case 'label':
							return value;
						case 'instrumentid':
							rowInstrumentid = value;
							return false;
						case 'venueid':
							rowVenueid = value;
							return false;
						case 'side':
							rowSide = value;
							return value === 'SELL' ? 'Verkauf' : 'Kauf';
						case 'quantity':
							rowQuantity = value;
							return value;
						case 'limitprice':
							rowLimitprice = value;
							return value;
						case 'placeicon':
							return (
								<span
									className="bi bi-send module-icon"
									title="Order platzieren"
									onClick={(e) => {
										e.stopPropagation();
										setPlaceTarget({
											connectionid: rowConnectionid,
											accountlabel: rowAccountlabel,
											instrumentid: rowInstrumentid,
											venueid: rowVenueid,
											side: rowSide,
											quantity: rowQuantity,
											limitprice: rowLimitprice,
										});
									}}
								></span>
							);
						default:
							return false;
					}
				}}
				onEditRow={(e, rowFields, rowId) => {
					x.waf.setAddSend(wafId, 'id', rowFields.templateid);
					x.waf.set(wafId, 'connectionid', rowFields.connectionid);
					x.waf.set(wafId, 'label', rowFields.label);
					x.waf.set(wafId, 'instrumentid', rowFields.instrumentid);
					x.waf.set(wafId, 'venueid', rowFields.venueid);
					x.waf.set(wafId, 'side', rowFields.side);
					x.waf.set(wafId, 'quantity', rowFields.quantity);
					x.waf.set(wafId, 'limitprice', rowFields.limitprice);
					x.waf.hide(wafId, 'message');
					x.wad[dialogFormId].setTitle("Ordervorlage bearbeiten");
					x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'label') });
				}}
				formFields={formFields}
				formSendTask="BrokerageTemplateSave"
			/>
			{placeTarget &&
				<TemplatePlaceOrder x={x} template={placeTarget} onClose={() => { setPlaceTarget(null); setReloadKey((k) => k + 1); }} />
			}
		</React.Fragment>
	)

};

// Login -> (bei mehreren Depots: Auswahl) -> vorausgefuelltes Order-Formular.
// Die Vorlage kennt keine depotId (die haengt an der comdirect-Verbindung,
// nicht an der Vorlage) - deshalb wird sie hier wie in BrokerageOverview.js
// live nachgeladen.
function TemplatePlaceOrder({ x, template, onClose }) {
	const [loggedIn, setLoggedIn] = React.useState(false);
	const [depots, setDepots] = React.useState(null);
	const [depotId, setDepotId] = React.useState(null);
	const [error, setError] = React.useState('');

	function loadDepots() {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageDepotList', { connectionId: template.connectionid }, (result) => {
			const content = result.data.content || {};
			if (result.data.returncode !== 1) {
				if (content.status === 'login-required') {
					setLoggedIn(false);
					return;
				}
				setError(content.message || 'Depot konnte nicht geladen werden.');
				return;
			}
			const loaded = content.depots || [];
			setDepots(loaded);
			if (loaded.length === 1) setDepotId(loaded[0].depotId);
		});
	}

	React.useEffect(() => {
		if (loggedIn) loadDepots();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loggedIn]);

	if (!loggedIn) {
		return (
			<div className="brokerage-overlay">
				<BrokerageLoginForm
					x={x}
					connectionId={template.connectionid}
					accountLabel={template.accountlabel}
					pinUse={true}
					pinStored={false}
					onLoggedIn={() => setLoggedIn(true)}
				/>
				<button type="button" className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
			</div>
		);
	}

	if (depotId === null) {
		return (
			<div className="brokerage-overlay">
				{error !== '' && <p className="brokerage-error"><i className="bi bi-exclamation-triangle"></i> {error}</p>}
				{depots === null && <p>Lade Depot…</p>}
				<div className="brokerage-picker">
					{(depots || []).map((depot) => (
						<div key={depot.depotId} className="brokerage-picker-item" onClick={() => setDepotId(depot.depotId)}>
							Depot {depot.depotDisplayId}
						</div>
					))}
				</div>
				<button type="button" className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
			</div>
		);
	}

	return (
		<div className="brokerage-overlay">
			<BrokerageOrderForm
				x={x}
				connectionId={template.connectionid}
				instrumentLabel={template.label}
				initialOrder={{
					depotId,
					settlementAccountId: ((depots || []).find((d) => d.depotId === depotId) || {}).settlementAccountId,
					instrumentId: template.instrumentid,
					venueId: template.venueid,
					side: template.side,
					quantity: String(template.quantity),
					limitPrice: String(template.limitprice),
				}}
				onCancel={onClose}
				onDone={onClose}
			/>
		</div>
	);
}
